/* AIR, 25 Oct 2026. Cart drawer gift line.
   Live discounts (set 2 to 3 Oct): 2 physical things -> Pocket Pep-Talk Cards free;
   3 physical things -> Pep-Talk Cards and Little Things journal free.
   The free printable has to be in the cart for the discount to apply, so we say so and offer a one-tap add. */
(function () {
  var PEP = 67396573331746, JOURNAL = 67396563108130;
  var busy = false, last = '';
  function physicalQty(cart) {
    return cart.items.reduce(function (n, it) { return n + (it.requires_shipping ? it.quantity : 0); }, 0);
  }
  function has(cart, id) { return cart.items.some(function (it) { return it.variant_id === id; }); }
  function message(cart) {
    var n = physicalQty(cart);
    if (n === 0) return null;
    if (n === 1) return { text: 'Add one more thing and the Pocket Pep-Talk Cards (a $9 printable) are on us.' };
    if (n === 2) {
      if (!has(cart, PEP)) return { text: 'The Pocket Pep-Talk Cards are on us with 2 things.', add: PEP, label: 'Add them free' };
      return { text: 'Pep-Talk Cards on us. Add one more thing and the Little Things journal is on us too.' };
    }
    if (!has(cart, PEP)) return { text: 'With 3 things, both printables are on us.', add: PEP, label: 'Add the Pep-Talk Cards free' };
    if (!has(cart, JOURNAL)) return { text: 'With 3 things, the Little Things journal is on us too.', add: JOURNAL, label: 'Add the journal free' };
    return { text: 'Both printables are on us. They arrive by email, right after you pay.' };
  }
  function refreshDrawer() {
    var cd = document.querySelector('cart-drawer');
    return fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (sections) {
      if (cd && typeof cd.renderContents === 'function') {
        cd.renderContents({ sections: sections });
        if (cd.classList.contains('is-empty')) cd.classList.remove('is-empty');
      }
    });
  }
  function render(cart) {
    var footer = document.querySelector('cart-drawer .drawer__footer');
    if (!footer) return;
    var old = footer.querySelector('.ymhp-gift-line');
    var m = message(cart);
    var key = JSON.stringify(m);
    if (old && key === last) return;
    if (old) old.remove();
    last = key;
    if (!m) return;
    var box = document.createElement('div');
    box.className = 'ymhp-gift-line';
    var p = document.createElement('p');
    p.textContent = m.text;
    box.appendChild(p);
    if (m.add) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ymhp-gift-line__btn';
      b.textContent = m.label;
      b.addEventListener('click', function () {
        b.disabled = true; b.textContent = 'Adding...';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: m.add, quantity: 1 }] }) })
          .then(refreshDrawer).then(check).catch(function () { b.disabled = false; b.textContent = m.label; });
      });
      box.appendChild(b);
    }
    footer.insertBefore(box, footer.firstChild);
  }
  function check() {
    if (busy) return Promise.resolve(); busy = true;
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { last = ''; render(cart); })
      .catch(function () {}).then(function () { busy = false; });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(check, 250); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check); else check();
  document.addEventListener('DOMContentLoaded', function () {
    var cd = document.querySelector('cart-drawer');
    if (cd) new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) { if (!(ms[i].target.closest && ms[i].target.closest('.ymhp-gift-line'))) { soon(); return; } }
    }).observe(cd, { childList: true, subtree: true });
  });
})();
